import type {
  Category,
  CategoryListResponseDataItemCustom,
} from '@twisto/api-cms'

import { ContentNavigation } from 'homepage/components/molecules'

import { CategoryContentNavigationCategories } from './category-content-navigation-categories'
import { getTopLevelCategoryAttributes } from './helpers'

type Props = {
  parent: Category
}

export const CategoryContentNavigation = ({ parent }: Props) => {
  const topLevelAttributes = getTopLevelCategoryAttributes(parent)

  return (
    <ContentNavigation>
      <CategoryContentNavigationCategories
        categories={
          topLevelAttributes?.categories as Array<
            CategoryListResponseDataItemCustom['attributes']
          >
        }
      />
    </ContentNavigation>
  )
}
